// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../common.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Roles page */
.admin-td-name {
  font-weight: 600 !important;
  color: #1a202c !important;
}

.admin-perms-summary {
  color: #64748b !important;
  font-size: 13px !important;
  max-width: 320px !important;
  display: inline-block !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.admin-field-label {
  display: block !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #374151 !important;
  margin-bottom: 8px !important;
}

.admin-field-hint {
  margin: -4px 0 10px !important;
  font-size: 13px !important;
  color: #64748b !important;
  line-height: 1.4 !important;
}

/* Data access settings card */
.admin-settings-card {
  border: 1px solid #e2e8f0 !important;
  border-radius: 10px !important;
  background: #fff !important;
  overflow: hidden !important;
}

.admin-settings-row {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 16px !important;
  padding: 14px 16px !important;
}

.admin-settings-row-content {
  display: flex !important;
  flex-direction: column !important;
  gap: 2px !important;
  min-width: 0 !important;
}

.admin-settings-row-title {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #1e293b !important;
  line-height: 1.4 !important;
}

.admin-settings-row-desc {
  font-size: 13px !important;
  color: #64748b !important;
  line-height: 1.45 !important;
}

/* Toggle switch */
.admin-toggle {
  position: relative !important;
  display: inline-flex !important;
  flex-shrink: 0 !important;
  cursor: pointer !important;
}

.admin-toggle input {
  position: absolute !important;
  opacity: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.admin-toggle-track {
  display: block !important;
  width: 44px !important;
  height: 24px !important;
  background: #cbd5e1 !important;
  border-radius: 999px !important;
  transition: background 0.2s ease !important;
  position: relative !important;
}

.admin-toggle-track::after {
  content: "" !important;
  position: absolute !important;
  top: 2px !important;
  left: 2px !important;
  width: 20px !important;
  height: 20px !important;
  background: #fff !important;
  border-radius: 50% !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12) !important;
  transition: transform 0.2s ease !important;
}

.admin-toggle input:checked + .admin-toggle-track {
  background: #3b82f6 !important;
}

.admin-toggle input:checked + .admin-toggle-track::after {
  transform: translateX(20px) !important;
}

.admin-toggle input:focus-visible + .admin-toggle-track {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2) !important;
}

/* Table data scope labels */
.admin-data-scope {
  display: inline-block !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  padding: 3px 10px !important;
  border-radius: 999px !important;
  line-height: 1.4 !important;
}

.admin-data-scope--all {
  background: #f0fdf4 !important;
  color: #15803d !important;
  border: 1px solid #bbf7d0 !important;
}

.admin-data-scope--assigned {
  background: #f8fafc !important;
  color: #64748b !important;
  border: 1px solid #e2e8f0 !important;
}

.admin-form-group-permissions .admin-field-label {
  margin-bottom: 4px !important;
}

.admin-permissions-box {
  border: 1px solid #e2e8f0 !important;
  border-radius: 10px !important;
  background: #f8fafc !important;
  overflow: hidden !important;
}

.admin-permissions-header {
  padding: 14px 18px !important;
  background: #f1f5f9 !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.admin-check-label.admin-select-all {
  font-weight: 600 !important;
  color: #1e293b !important;
  gap: 10px !important;
}

.admin-permissions-list {
  max-height: 320px !important;
  overflow-y: auto !important;
  padding: 12px 20px 20px !important;
}

.admin-permissions-section {
  margin-bottom: 18px !important;
}

.admin-permissions-section:last-child {
  margin-bottom: 0 !important;
}

.admin-permissions-section-title {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #334155 !important;
  letter-spacing: 0.01em !important;
  margin-bottom: 10px !important;
  padding-bottom: 6px !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.admin-permissions-grid {
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)) !important;
  gap: 10px 20px !important;
  padding: 0 !important;
  max-height: none !important;
  overflow-y: visible !important;
}

.admin-check-label {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  font-size: 14px !important;
  color: #475569 !important;
  cursor: pointer !important;
  padding: 6px 0 !important;
  transition: color 0.15s ease !important;
}

.admin-check-label:hover {
  color: #1e293b !important;
}

.admin-check-label input {
  flex-shrink: 0 !important;
  width: 18px !important;
  height: 18px !important;
  accent-color: #3b82f6 !important;
  cursor: pointer !important;
}

.admin-check-label input:indeterminate {
  accent-color: #3b82f6 !important;
}

/* Wider modal for role form */
.admin-page-container .admin-modal {
  max-width: 640px !important;
}

@media (max-width: 768px) {
  .admin-settings-row {
    align-items: flex-start !important;
  }

  .admin-permissions-list {
    padding: 12px 16px 16px !important;
  }

  .admin-permissions-grid {
    grid-template-columns: 1fr !important;
    gap: 8px !important;
  }

  .admin-permissions-header {
    padding: 12px 16px !important;
  }

  .admin-perms-summary {
    white-space: normal !important;
    max-width: none !important;
    overflow: visible !important;
    text-overflow: unset !important;
  }
}

/* ===== Dark theme overrides (light mode untouched) ===== */
[data-theme="dark"] .admin-td-name,
[data-theme="dark"] .admin-settings-row-title,
[data-theme="dark"] .admin-check-label.admin-select-all,
[data-theme="dark"] .admin-check-label:hover {
  color: var(--text) !important;
}
[data-theme="dark"] .admin-perms-summary,
[data-theme="dark"] .admin-field-hint,
[data-theme="dark"] .admin-settings-row-desc,
[data-theme="dark"] .admin-check-label {
  color: var(--text-muted) !important;
}
[data-theme="dark"] .admin-field-label,
[data-theme="dark"] .admin-permissions-section-title {
  color: var(--text) !important;
  border-bottom-color: var(--border) !important;
}
[data-theme="dark"] .admin-settings-card,
[data-theme="dark"] .admin-permissions-box {
  border-color: var(--border) !important;
  background: var(--surface-2) !important;
}
[data-theme="dark"] .admin-permissions-header {
  background: var(--surface-3) !important;
  border-bottom-color: var(--border) !important;
}
[data-theme="dark"] .admin-toggle-track {
  background: var(--border-strong) !important;
}
[data-theme="dark"] .admin-data-scope--assigned {
  background: var(--surface-2) !important;
  color: var(--text-muted) !important;
  border-color: var(--border) !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/Roles/index.css"],"names":[],"mappings":"AAEA,eAAe;AACf;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,oDAAoD;EACpD,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,uEAAuE;EACvE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,0BAA0B;IAC1B,4BAA4B;IAC5B,+BAA+B;EACjC;AACF;;AAEA,4DAA4D;AAC5D;;;;EAIE,6BAA6B;AAC/B;AACA;;;;EAIE,mCAAmC;AACrC;AACA;;EAEE,6BAA6B;EAC7B,6CAA6C;AAC/C;AACA;;EAEE,sCAAsC;EACtC,uCAAuC;AACzC;AACA;EACE,uCAAuC;EACvC,6CAA6C;AAC/C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,sCAAsC;AACxC","sourcesContent":["@import \"../common.css\";\n\n/* Roles page */\n.admin-td-name {\n  font-weight: 600 !important;\n  color: #1a202c !important;\n}\n\n.admin-perms-summary {\n  color: #64748b !important;\n  font-size: 13px !important;\n  max-width: 320px !important;\n  display: inline-block !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n\n.admin-field-label {\n  display: block !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  color: #374151 !important;\n  margin-bottom: 8px !important;\n}\n\n.admin-field-hint {\n  margin: -4px 0 10px !important;\n  font-size: 13px !important;\n  color: #64748b !important;\n  line-height: 1.4 !important;\n}\n\n/* Data access settings card */\n.admin-settings-card {\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 10px !important;\n  background: #fff !important;\n  overflow: hidden !important;\n}\n\n.admin-settings-row {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 16px !important;\n  padding: 14px 16px !important;\n}\n\n.admin-settings-row-content {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 2px !important;\n  min-width: 0 !important;\n}\n\n.admin-settings-row-title {\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: #1e293b !important;\n  line-height: 1.4 !important;\n}\n\n.admin-settings-row-desc {\n  font-size: 13px !important;\n  color: #64748b !important;\n  line-height: 1.45 !important;\n}\n\n/* Toggle switch */\n.admin-toggle {\n  position: relative !important;\n  display: inline-flex !important;\n  flex-shrink: 0 !important;\n  cursor: pointer !important;\n}\n\n.admin-toggle input {\n  position: absolute !important;\n  opacity: 0 !important;\n  width: 0 !important;\n  height: 0 !important;\n}\n\n.admin-toggle-track {\n  display: block !important;\n  width: 44px !important;\n  height: 24px !important;\n  background: #cbd5e1 !important;\n  border-radius: 999px !important;\n  transition: background 0.2s ease !important;\n  position: relative !important;\n}\n\n.admin-toggle-track::after {\n  content: \"\" !important;\n  position: absolute !important;\n  top: 2px !important;\n  left: 2px !important;\n  width: 20px !important;\n  height: 20px !important;\n  background: #fff !important;\n  border-radius: 50% !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12) !important;\n  transition: transform 0.2s ease !important;\n}\n\n.admin-toggle input:checked + .admin-toggle-track {\n  background: #3b82f6 !important;\n}\n\n.admin-toggle input:checked + .admin-toggle-track::after {\n  transform: translateX(20px) !important;\n}\n\n.admin-toggle input:focus-visible + .admin-toggle-track {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2) !important;\n}\n\n/* Table data scope labels */\n.admin-data-scope {\n  display: inline-block !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  padding: 3px 10px !important;\n  border-radius: 999px !important;\n  line-height: 1.4 !important;\n}\n\n.admin-data-scope--all {\n  background: #f0fdf4 !important;\n  color: #15803d !important;\n  border: 1px solid #bbf7d0 !important;\n}\n\n.admin-data-scope--assigned {\n  background: #f8fafc !important;\n  color: #64748b !important;\n  border: 1px solid #e2e8f0 !important;\n}\n\n.admin-form-group-permissions .admin-field-label {\n  margin-bottom: 4px !important;\n}\n\n.admin-permissions-box {\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 10px !important;\n  background: #f8fafc !important;\n  overflow: hidden !important;\n}\n\n.admin-permissions-header {\n  padding: 14px 18px !important;\n  background: #f1f5f9 !important;\n  border-bottom: 1px solid #e2e8f0 !important;\n}\n\n.admin-check-label.admin-select-all {\n  font-weight: 600 !important;\n  color: #1e293b !important;\n  gap: 10px !important;\n}\n\n.admin-permissions-list {\n  max-height: 320px !important;\n  overflow-y: auto !important;\n  padding: 12px 20px 20px !important;\n}\n\n.admin-permissions-section {\n  margin-bottom: 18px !important;\n}\n\n.admin-permissions-section:last-child {\n  margin-bottom: 0 !important;\n}\n\n.admin-permissions-section-title {\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  color: #334155 !important;\n  letter-spacing: 0.01em !important;\n  margin-bottom: 10px !important;\n  padding-bottom: 6px !important;\n  border-bottom: 1px solid #e2e8f0 !important;\n}\n\n.admin-permissions-grid {\n  display: grid !important;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)) !important;\n  gap: 10px 20px !important;\n  padding: 0 !important;\n  max-height: none !important;\n  overflow-y: visible !important;\n}\n\n.admin-check-label {\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n  font-size: 14px !important;\n  color: #475569 !important;\n  cursor: pointer !important;\n  padding: 6px 0 !important;\n  transition: color 0.15s ease !important;\n}\n\n.admin-check-label:hover {\n  color: #1e293b !important;\n}\n\n.admin-check-label input {\n  flex-shrink: 0 !important;\n  width: 18px !important;\n  height: 18px !important;\n  accent-color: #3b82f6 !important;\n  cursor: pointer !important;\n}\n\n.admin-check-label input:indeterminate {\n  accent-color: #3b82f6 !important;\n}\n\n/* Wider modal for role form */\n.admin-page-container .admin-modal {\n  max-width: 640px !important;\n}\n\n@media (max-width: 768px) {\n  .admin-settings-row {\n    align-items: flex-start !important;\n  }\n\n  .admin-permissions-list {\n    padding: 12px 16px 16px !important;\n  }\n\n  .admin-permissions-grid {\n    grid-template-columns: 1fr !important;\n    gap: 8px !important;\n  }\n\n  .admin-permissions-header {\n    padding: 12px 16px !important;\n  }\n\n  .admin-perms-summary {\n    white-space: normal !important;\n    max-width: none !important;\n    overflow: visible !important;\n    text-overflow: unset !important;\n  }\n}\n\n/* ===== Dark theme overrides (light mode untouched) ===== */\n[data-theme=\"dark\"] .admin-td-name,\n[data-theme=\"dark\"] .admin-settings-row-title,\n[data-theme=\"dark\"] .admin-check-label.admin-select-all,\n[data-theme=\"dark\"] .admin-check-label:hover {\n  color: var(--text) !important;\n}\n[data-theme=\"dark\"] .admin-perms-summary,\n[data-theme=\"dark\"] .admin-field-hint,\n[data-theme=\"dark\"] .admin-settings-row-desc,\n[data-theme=\"dark\"] .admin-check-label {\n  color: var(--text-muted) !important;\n}\n[data-theme=\"dark\"] .admin-field-label,\n[data-theme=\"dark\"] .admin-permissions-section-title {\n  color: var(--text) !important;\n  border-bottom-color: var(--border) !important;\n}\n[data-theme=\"dark\"] .admin-settings-card,\n[data-theme=\"dark\"] .admin-permissions-box {\n  border-color: var(--border) !important;\n  background: var(--surface-2) !important;\n}\n[data-theme=\"dark\"] .admin-permissions-header {\n  background: var(--surface-3) !important;\n  border-bottom-color: var(--border) !important;\n}\n[data-theme=\"dark\"] .admin-toggle-track {\n  background: var(--border-strong) !important;\n}\n[data-theme=\"dark\"] .admin-data-scope--assigned {\n  background: var(--surface-2) !important;\n  color: var(--text-muted) !important;\n  border-color: var(--border) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
